import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      width: "100vw",
      height: "100vh",
      backgroundColor: theme.colors.background,
      display: "flex",
      flexDirection: "column",
    },
    header: {
      height: 60,
      minHeight: 60,
      borderBottom: `1px solid ${theme.colors.divider}`,
    },
    body: {
      display: "flex",
      flexDirection: "row",
      flex: 1,
    },
    menu: {
      width: 240,
      minWidth: 240,
      height: "100%",
    },
    main: {
      flex: 1,
      height: "calc(100vh - 60px)",
      display: "flex",
      flexDirection: "column",
    },
    errorHeader: {
      ...theme.fonts.h3,
      color: theme.colors.textDefault,
    },
    errorCode: {
      marginTop: 8,
      ...theme.fonts.h6,
      color: theme.colors.textSubtle,
    },
    links: {
      color: theme.colors.action,
      fontWeight: "bold",
    },
    errorMessage: {
      marginTop: 8,
      ...theme.fonts.p1,
    },
    contentContainer: {
      maxWidth: 525,
      marginLeft: 32,
      marginTop: 60,
    },
    info: {
      width: 340,
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
